import { NUMBER } from "../constants/app-constants";
import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const BASE_URL = "/api/v1/bff-schema";
const superAppCmsService = (api) => {
    const getCmsData = (bannerType) => {
        return api.get(`${BASE_URL}/page/page-template/${bannerType}`);
    };
    const getCarouselData = ({slugId, slugValue}) => {
        return api.get(`${BASE_URL}/consumer-api/carousel?categorySlug=${slugId}_${slugValue}`);
    };
    const getPageTemplate = (pageTemplate) => {
        return api.get(`${BASE_URL}/page/page-template/${pageTemplate}`);
    };

    const getVehicleRegistry = async ({ authToken }) => {
        try {
            const response = await api.get(`/api/v1/vehicle-service/rc/mobile-number`, {
                headers: {
                    ...(authToken && { "Authorization": `Bearer ${authToken}` })
                }
            });
            const data = response.data.data.map((item) => {
                return {
                    vehicleRegNo: item.label.replace(/[\s-]/g, "")
                };
            });
            return (data || []).slice(0, NUMBER.SIX);
        } catch (e) {
            return { error: e };
        }
    };
    const getRepeatUserDetails = (payload) => {
        return api.get(`${BASE_URL}/page/repeat-user-appointment-details`, {   // TODO: update the endpoint
            params: payload
        });
    };

    return {
        getCmsData,
        getPageTemplate,
        getCarouselData,
        getVehicleRegistry,
        getRepeatUserDetails
    };
};

export const SuperAppCmsService = superAppCmsService(middlewareConfig(MIDDLEWARE_ENUMS.SUPER_APP_CMS_SERVICE));
